var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.loading
        ? _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "64",
                  color: "primary"
                }
              })
            ],
            1
          )
        : [
            _c(
              "v-col",
              {
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "card-title",
                  {
                    staticClass: "pt-0"
                  },
                  [
                    _vm._v(
                      " Service Alert for " +
                        _vm._s(_vm.alert.serviceDomain) +
                        " "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "body-2 pl-md-2",
                        attrs: {
                          to: {
                            name: "hosting_alerts"
                          }
                        }
                      },
                      [_vm._v(" Back to all alerts ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "pt-0",
                attrs: {
                  cols: "12"
                }
              },
              [
                _c("alert-card", {
                  attrs: {
                    alert: _vm.alert
                  }
                })
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "pt-8",
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "h3",
                  {
                    staticClass: "mb-0"
                  },
                  [_vm._v(" Your Options ")]
                )
              ]
            ),
            _vm.selfResolveAvailable
              ? _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("self-resolve", {
                      attrs: {
                        steps: _vm.alertData.option_selfresolve
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.upgradeAvailable
              ? _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("upgrade", {
                      attrs: {
                        alert: _vm.alertData
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.helpAvailable
              ? _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "4"
                    }
                  },
                  [
                    _c("help", {
                      attrs: {
                        alert: _vm.alertData
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }